export default __webpack_public_path__ + "static/media/185.ede74cad.jpg";